export default __webpack_public_path__ + "static/media/sample.9668a976.mp4";